<template>
	<div class="letter_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('user.setting')}}</div>
		</div>
		<van-cell is-link @click="$router.push('/language')">
		  <template #title>
			<van-icon name="list-switching" size="22" style="padding-right: 10px;"/>
		    <span class="custom-title">{{$t('safe.language')}}</span>
		  </template>
		</van-cell>
		<van-cell is-link @click="$router.push('/setpwd')">
		  <template #title>
			<van-icon name="lock" size="22" style="padding-right: 10px;"/>
		    <span class="custom-title">{{$t('safe.signInPassword')}}</span>
		  </template>
		</van-cell>
		<!-- <van-cell is-link @click="$router.push('/setpaypwd')">
		  <template #title>
			<van-icon name="shield-o" size="22" style="padding-right: 10px;"/>
		    <span class="custom-title">{{$t('safe.paymentPassword')}}</span>
		  </template>
		</van-cell> -->

		<van-cell >
		  <template #title>
			<van-icon name="brush-o" size="22" style="padding-right: 10px;"/>
		    <span class="custom-title">{{$t('feng.cache')}}</span>
		  </template>
		</van-cell>
	<!-- 	<van-cell is-link >
		  <template #title>
			<van-icon name="warning-o" size="22" style="padding-right: 10px;"/>
		    <span class="custom-title">{{$t('index.aboutUs')}}</span>
		  </template>
		</van-cell>
		<van-cell is-link >
		  <template #title>
			<a v-if="app" :href="app.kefu_link" target="_blank" style="color: #000;">
				<van-icon name="chat" size="22" style="padding-right: 10px;"/>
				<span class="custom-title">{{$t('feng.back')}}</span>
			</a>
		  </template>
		</van-cell> -->
		<van-cell value=" V1.0.0 ">
		  <template #title>
			<van-icon name="info-o" size="22" style="padding-right: 10px;"/>
		    <span class="custom-title">{{$t('feng.version')}}</span>
		  </template>
		</van-cell>
		
		
		<div style="margin: 3vw;">
			<div class="history_coupon flex_center basic_btn" @click="logout">
				<span>{{$t('safe.signOut')}}</span>
			</div>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';

	export default {
		name: "set",
		data() {
			return {
				title:"title_"+ (this.$i18n.locale||"zh_cn"),
				content:"content_"+ (this.$i18n.locale||"zh_cn"),
				app:null,
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
				});
			},
			logout() {
				localStorage.removeItem('token');
				this.$router.replace("/");
			}
		}
	};
</script>

<style lang="less" scoped>
	.red_top_bg {
		position: relative;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: 10;
	}
	
</style>
